import React, { forwardRef } from 'react'
import LazyLoad from 'react-lazy-load'
import { fileInParts, getResolutions, putImagePath } from '@/lib/images'
import { IMetadata } from '@/lib/files/types'
import { ImageContainer, StyledImage } from './PostImage.styles'

interface IProps {
  meta: IMetadata
  slug: string
}

const PostImage = forwardRef<HTMLImageElement, IProps>(
  ({ meta, slug }, ref) => {
    const { name, extension } = fileInParts(meta.image)
    const fullImageName = putImagePath(name, slug)
    const resolutions = getResolutions(fullImageName, extension)
    const webpResolutions = getResolutions(fullImageName, 'webp')
    const avifResolutions = getResolutions(fullImageName, 'avif')
    const altComment = `Imagen de ${meta.title}`

    return (
      <ImageContainer>
        <LazyLoad>
          <picture>
            <source type='image/webp' srcSet={webpResolutions} />
            <source type='image/avif' srcSet={avifResolutions} />
            <source srcSet={resolutions} />
            <StyledImage ref={ref} src={`${fullImageName}`} alt={altComment} />
          </picture>
        </LazyLoad>
      </ImageContainer>
    )
  }
)

PostImage.displayName = 'PostImage'

export default PostImage
